// TODO: move all into topically appropriate ./reusable/???.js


// Array.contains(obj)
// Array.prototype.contains = Array.prototype.contains || function(obj)
// {
//   var i, l = this.length;
//   for (i = 0; i < l; i++)
//   {
//     if (this[i] === obj) return true;
//   }
//   return false;
// };

// Array.remove(obj)
// Array.prototype.remove = Array.prototype.remove || function(obj)
// {
//   var i, l = this.length;
//   for (i = 0; i < l; i++)
//   {
//     if (this[i] === obj) {
//       this.splice(i, 1);
//       return obj;
//     }
//   }
//   return null;
// };

// Array.last()
// Array.prototype.last = Array.prototype.last || function(){
//   return this[this.length - 1];
// };

// Array.lastOrDefault()
// Array.prototype.lastOrDefault = Array.prototype.lastOrDefault || function(){
//   if (this.length==0)
//     return null;
//   return this[this.length - 1];
// };

// Array.first()
// Array.prototype.first = Array.prototype.first || function(){
//   return this[0];
// };

// Array.firstOrDefault()
// Array.prototype.firstOrDefault = Array.prototype.firstOrDefault || function(){
//   if (this.length==0)
//     return null;
//   return this[0];
// };

// Array.distinct()
// Array.prototype.distinct = Array.prototype.distinct || function(){
//   return this.filter((elem, pos, arr) => arr.indexOf(elem) === pos);
// };

// Array.clear()
// Array.prototype.clear = Array.prototype.clear || function(){
//   return this.splice(0);
// };

// Array.findIndex(x=>{...})
// if (!Array.prototype.findIndex) {
//   Object.defineProperty(Array.prototype, 'findIndex', {
//     value: function(predicate) {
//       // 1. Let O be ? ToObject(this value).
//       if (this == null) {
//         throw new TypeError('"this" is null or not defined');
//       }
//
//       var o = Object(this);
//
//       // 2. Let len be ? ToLength(? Get(O, "length")).
//       var len = o.length >>> 0;
//
//       // 3. If IsCallable(predicate) is false, throw a TypeError exception.
//       if (typeof predicate !== 'function') {
//         throw new TypeError('predicate must be a function');
//       }
//
//       // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
//       var thisArg = arguments[1];
//
//       // 5. Let k be 0.
//       var k = 0;
//
//       // 6. Repeat, while k < len
//       while (k < len) {
//         // a. Let Pk be ! ToString(k).
//         // b. Let kValue be ? Get(O, Pk).
//         // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
//         // d. If testResult is true, return k.
//         var kValue = o[k];
//         if (predicate.call(thisArg, kValue, k, o)) {
//           return k;
//         }
//         // e. Increase k by 1.
//         k++;
//       }
//
//       // 7. Return -1.
//       return -1;
//     }
//   });
// }

// Array.prototype.sortBy = Array.prototype.sortBy || function(predicate, descending) {
//   this.sort((obja,objb)=> {
//     var a = predicate(obja);
//     var b = predicate(objb);
//     if (descending)
//     {
//       var c=a;
//       a=b;
//       b=c;
//     }
//     switch (typeof a) {
//       case "string":
//         return a.localeCompare(b); // .toLowerCase();
//       default:
//         if (a < b)
//           return -1;
//         else if (a==b)
//           return 0;
//         else
//           return 1;
//     }
//   });
//   return this;
// };
//
// Array.prototype.sortByDescending = Array.prototype.sortByDescending || function(predicate) {
//   this.sortBy(predicate, true);
//   return this;
// }
//
// Array.prototype.maxBy=Array.prototype.maxBy || function(predicate) {
//     return this.reduce((prev, current) => (predicate(prev) > predicate(current)) ? prev : current);
// }
//
// Array.prototype.minBy=Array.prototype.minBy || function(predicate) {
//     return this.reduce((prev, current) => (predicate(prev) < predicate(current)) ? prev : current);
// }

// Object.getPairs()
/// Return array of key-value-pairs for an object
// Object.defineProperty(Object.prototype, 'getPairs', {
//   value: function() {
//     return Object.keys(this).map(k=>{return {key:k, value:this[k]}});
//   },
//   enumerable: false, // make sure enumerating over any object doesn't return this function
// });

// Object.eachPair((k,v)=>{...})
/// Call given function for every key-value-pair
// Object.defineProperty(Object.prototype, 'eachPair', {
//   value: function(predicate) {
//     return Object.keys(this).forEach(k=> predicate(k, this[k]));
//   },
//   enumerable: false, // make sure enumerating over any object doesn't return this function
// });


// export function precisionRound(number, precision) {
//   var factor = Math.pow(10, precision);
//   return Math.round(number * factor) / factor;
// }

export function query(data) {
  let ret = [];
  for (let d in data)
    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
  return ret.join('&');
}

export function isValidAmountOfMoney(v)
{
  if (!v)
    return false;
  if(!/^\s*[+-]?\s*\d+(\.\d\d\d)*(,\d+)?\s*$/.test(v))
    return false;
  return true;
};

export function isValidInteger(intString) {
  if (intString==undefined || intString==null)
    return false;
  if(!/^\s*[+-]?\s*\d+\s*$/.test(intString))
    return false;
  return true;
}

export function isValidFloat(numString) {
  if (numString==undefined || numString==null)
    return false;
  if(!/^\s*[+-]?\s*\d+(,\d+)?\s*$/.test(numString))
    return false;
  return true;
}

export function parseUserInputDate(dateString) {
  if (!dateString)
    return null;
  return moment.utc(dateString,["DD-MM-YYYY", "DD-MM", "YYYY-MM-DD","DD.MM.YYYY", "DD.MM", "YYYY.MM.DD", "DD"], 'de-de').toDate();
}

export function parseUserInputInteger(intString) {
  return parseInt(intString, 10);
}

// export function parseUserInputBetrag(betragString) {
//   if (!betragString)
//     return null;
//   var b1=betragString.replace(/\./g , "");
//   var b2=b1.replace(/,/g , ".");
//   var b3=parseFloat(b2);
//   return precisionRound(b3,2);
// }

export function formatBetrag(betrag, decimals) {
  if (betrag===null || betrag ===undefined)
    return "";
  // var formatter = new Intl.NumberFormat('de-DE', {
  //    style: 'decimal', // 'currency'
  //   // currency: 'EUR',
  //   minimumFractionDigits: 2,
  //   // the default value for minimumFractionDigits depends on the currency
  //   // and is usually already 2
  // });
  // // return betrag.toLocaleString('de-DE', {minimumFractionDigits: 2});
  // return formatter.format(betrag);
  return betrag.toMoney(decimals||2, ',', '.');
}

/*
decimal_sep: character used as deciaml separtor, it defaults to '.' when omitted
thousands_sep: char used as thousands separator, it defaults to ',' when omitted
*/
Number.prototype.toMoney = function(decimals, decimal_sep, thousands_sep)
{
  var n = this,
    c = isNaN(decimals) ? 2 : Math.abs(decimals), //if decimal is zero we must take it, it means user does not want to show any decimal
    d = decimal_sep || '.', //if no decimal separator is passed we use the dot as default decimal separator (we MUST use a decimal separator)

    /*
    according to [https://stackoverflow.com/questions/411352/how-best-to-determine-if-an-argument-is-not-sent-to-the-javascript-function]
    the fastest way to check for not defined parameter is to use typeof value === 'undefined'
    rather than doing value === undefined.
    */
    t = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep, //if you don't want to use a thousands separator you can pass empty string as thousands_sep value

    sign = (n < 0) ? '-' : '',

    //extracting the absolute value of the integer part of the number and converting to string (radix 10, just to make sure)
    i = parseInt(n = Math.abs(n).toFixed(c), 10) + '',

    j = ((j = i.length) > 3) ? j % 3 : 0;
  return sign + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
}

export function formatDatum(datum) {
  if (!datum)
    return "";
  var d=new Date(datum);
  var day=d.getDate();
  var month=d.getMonth()+1;   // note: month is zero based!!!!
  var year=d.getFullYear();
  if (Number.isNaN(day) || !Number.isFinite(day))
    return "";
  if (Number.isNaN(month) || !Number.isFinite(month))
    return "";
  if (Number.isNaN(year) || !Number.isFinite(year))
    return "";
  return formatIntLeadingZeros(day,2) +"."+ formatIntLeadingZeros(month,2)+"."+year;
}

// expects a date object
export function formatIsoDate(date) {
    return date.getFullYear() +  "-"+ formatIntLeadingZeros(date.getMonth()+1,2)+"-"+formatIntLeadingZeros(date.getDate(),2);
}

// note: max size 10 characters!
export function formatIntLeadingZeros(num, size) {
  var num_str=num.toString();
  if (num_str.length >= size)
    return num_str;
  var s = "000000000" + num_str;
  return s.substr(s.length-size);
}

export function toUtc(datum) {
  if (!datum)
    return null;
  var d = new Date(datum);
  var utc=new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  return utc;
}

export function convertToInt(input) {
  switch(typeof input) {
    case 'number':
      if (isNaN(input) || !isFinite(input))
        return 0;
      return Math.round(input);
    case 'string':
      var int = parseInt(input);
      if (isNaN(int) || !isFinite(int))
        return 0;
      return int;
    case 'boolean':
      return input ? 1 : 0;
    default:
      return 0;
  }
}

export function valueOrDefault(value, default_value) {
  if (value==null || value==undefined)
    return default_value;
  return value;
}

export function genericSortFunc(a, b) {
  switch (typeof a) {
    case "string":
      return a.localeCompare(b, 'de', { numeric: true });
    default:
      if (a < b)
        return -1;
      else if (a==b)
        return 0;
      else
        return 1;
  }
}
